export const OPEN_SEARCH_MODAL = "OPEN_SEARCH_MODAL";
export const CLOSE_SEARCH_MODAL = "CLOSE_SEARCH_MODAL";
export const openSearchModal = () => ({ type: OPEN_SEARCH_MODAL });
export const closeSearchModal = () => ({ type: CLOSE_SEARCH_MODAL });
